import axios from 'axios';

export default async function restoreDeletedCompanyGroup({
  accessToken,
  id,
  setTokenLikeExpired,
}) {
  try {
    const { data } = await axios.post(
      `${process.env.REACT_APP_COMPANY_GROUPS_API_URL}/restore/${id}`, null,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return data;
  } catch (err) {
    if (err.response?.status === 401 && setTokenLikeExpired) setTokenLikeExpired();

    return null;
  }
}
